// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__NJ11H","logo":"Sidebar_logo__c4Aur","menu":"Sidebar_menu__DnA4v","item":"Sidebar_item__udFVV"};